import { useState } from "react";
import { SweetAlertShow } from "../../../master/Master";
import { formatToDate } from "../../../master/FormatToDateTime";
import { studentDetailsBatchNFeeDetails } from "../../../../api/StudentDetails";

export const fmtMoney = (v) => `₹${Number(v || 0).toLocaleString()}`;

export const batchStatusMeta = (status) => {
  switch (String(status)) {
    case "1":
      return {
        label: "Active",
        color: "success",
        icon: "ri-play-circle-fill",
      };

    case "4":
      return {
        label: "Transferred",
        color: "danger",
        icon: "ri-arrow-right-circle-fill",
      };

    case "5":
      return {
        label: "Completed",
        color: "secondary",
        icon: "ri-checkbox-circle-fill",
      };

    default:
      return {
        label: "Inactive",
        color: "warning",
        icon: "ri-close-circle-fill",
      };
  }
};

export const Pill = ({ icon, color, label, value }) => (
  <span
    className={`badge rounded-pill bg-${color} bg-opacity-10 text-${color === "primary" ? "white" : color} d-inline-flex align-items-center gap-1 px-3 py-2`}
  >
    <i className={icon}></i>
    {label}: <span className="fw-semibold">{value}</span>
  </span>
);

export const feeStatusMeta = (paid, final) => {
  const p = Number(paid || 0);
  const f = Number(final || 0);
  const d=f-p;
  if (d > 0){
    return { label: "Due", color: "danger", icon: "ri-error-warning-line" };
  }
  if (d === 0){
    return { label: "Paid", color: "success", icon: "ri-checkbox-circle-line" };
  }
  return { label: "Partial", color: "warning", icon: "ri-time-line" };
};




